module.exports = __webpack_public_path__ + "static/dino-57bf26316e78f0d0c2ec62bb310d4537.jpg";